import React from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';

import { VideoPoster } from '../../ProductPageComponents/VideoPoster/VideoPoster';
import LocalTexts from '../DiscoverMWPay.texts.json';
import { useVideoModal } from '../FAQSection/VideoModal/useVideoModal';
import { VideoModal } from '../FAQSection/VideoModal/VideoModal';
import { ReactComponent as PayLogo } from '../images/payLogo.svg';

import styles from './HowItWorks.module.scss';

const LocalT = new MDText(LocalTexts);

const YOUTUBE_VIDEO_ID = `uspHSlMe9Xw`;

const ThumbnailImage: React.FC = () => {
	return (
		<div data-poster-image className={styles.thumbnailBackground}>
			<PayLogo width="40%" />
		</div>
	);
};

export const HowItWorks: React.FC = () => {
	const {
		closeModal: closeVideoModal,
		openModal: openVideoModal,
		state: isVideoModalOpen,
	} = useVideoModal({ eventName: 'Payments support video modal clicked' });

	const {
		minWidth: { breakpointTablet: isDesktop },
	} = useBreakpoint();

	return (
		<>
			<section className={styles.section}>
				<div className={cx(styles.container)}>
					<VideoPoster
						alt="Play Motorway Pay introduction video"
						className={styles.customThumbnail}
						customThumbnail={<ThumbnailImage />}
						onClick={openVideoModal}
						orientation={isDesktop ? 'left' : 'top'}
						showPlayButton={true}
						youtubeVideoId={YOUTUBE_VIDEO_ID}
					/>
					<div className={styles.text}>
						<h3>{LocalT.translate('howItWorks.heading')}</h3>
						<p>{LocalT.translate('howItWorks.content.paragraphOne')}</p>
						<ul className={styles.list}>
							<li>{LocalT.translate('howItWorks.content.listItemOne')}</li>
							<li>{LocalT.translate('howItWorks.content.listItemTwo')}</li>
							<li>{LocalT.translate('howItWorks.content.listItemThree')}</li>
							<li>{LocalT.translate('howItWorks.content.listItemFour')}</li>
						</ul>
					</div>
				</div>
			</section>
			{isVideoModalOpen && <VideoModal dismissModal={closeVideoModal} youtubeVideoId={YOUTUBE_VIDEO_ID} />}
		</>
	);
};
